module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-493.d93975d.woff2";